
  const coa = {
    path: "/lab-result/coa/:id",
    name: "coa",
    component: () => import(/* webpackChunkName: "coa" */ "@/components/inventoryLabResult/coa.vue"),
    meta: { authorize: ['Administrator', 'Manager', 'Factory', 'Technician'], requiresAuth: true }
  };

export default coa;